module.exports = __webpack_public_path__ + "static/media/receta-17.f1c203a4.png";